import { Button, Typography } from 'antd';
import React, { ReactElement } from 'react';
import Layout from './Layout';

export default function LoansProperties(): ReactElement {
    return (
        <Layout section='loans-properties-export'>
            <Typography.Title level={2}>Loans - Properties</Typography.Title>
            <Button
                href={`${process.env.API_HOST}/loans/download-property-report`}
                target='_blank'
                type='primary'
            >Download</Button>
        </Layout>
    );
}
